export const money = (v, cur = "£") =>
  `${cur}${Number(v || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const STATUS = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  submitted: { label: "Submitted", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  query_raised: { label: "Query Raised", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  approved: { label: "Approved", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rejected: { label: "Rejected", cls: "bg-red-50 text-red-700 border-red-200" },
};

export const barColor = { green: "#3E8755", amber: "#F29C38", red: "#D94E4E" };
export const pillColor = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  amber: "bg-amber-50 text-amber-700 border-amber-200",
  red: "bg-red-50 text-red-700 border-red-200",
};

function pad(n) { return String(n).padStart(2, "0"); }
function fmt(d) { return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; }

export function mondayOf(date) {
  const x = new Date(date);
  const day = (x.getDay() + 6) % 7;
  x.setDate(x.getDate() - day);
  x.setHours(0, 0, 0, 0);
  return x;
}

export function currentWeek() { return fmt(mondayOf(new Date())); }
export function todayStr() { return fmt(new Date()); }

export function recentWeeks(n = 10) {
  const base = mondayOf(new Date());
  const out = [];
  for (let i = 0; i < n; i++) {
    const d = new Date(base);
    d.setDate(d.getDate() - i * 7);
    out.push({ value: fmt(d), label: weekLabel(fmt(d)) });
  }
  return out;
}

export function weekLabel(ws) {
  const start = new Date(ws + "T00:00:00");
  const end = new Date(start);
  end.setDate(end.getDate() + 6);
  const o = { day: "2-digit", month: "short" };
  return `${start.toLocaleDateString("en-GB", o)} – ${end.toLocaleDateString("en-GB", { ...o, year: "numeric" })}`;
}

export const CHART_COLORS = ["#3E8755", "#F29C38", "#0F172A", "#4C7CB0", "#B07A4C", "#7A5CB0", "#D94E4E", "#4CB0A0"];
